/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { PeopleBold } from './people-bold'
import { PersonBold } from './person-bold'
import loadable from '@loadable/component'

const TruArrowCircle = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruArrowCircle,
})
const TruArrow = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruArrow,
})
const TruBill = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruBill,
})
const TruBookClosed = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruBookClosed,
})
const TruBook = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruBook,
})
const TruBookmarkFilled = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruBookmarkFilled,
})
const TruBookmark = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruBookmark,
})
const TruCalendar = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruCalendar,
})
const TruCar = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruCar,
})
const TruCaret = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruCaret,
})
const TruCaretFinal = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruCaretFinal,
})
const TruCheckCircle = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruCheckCircle,
})
const TruCheck = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruCheck,
})
const TruCheckmark = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruCheckmark,
})
const TruClock = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruClock,
})
const TruClose = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruClose,
})
const TruConversation = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruConversation,
})
const TruCross = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruCross,
})
const TruEditJourney = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruEditJourney,
})
const TruEdit = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruEdit,
})
const TruEmailFilled = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruEmailFilled,
})
const TruEmail = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruEmail,
})
const TruError = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruError,
})
const TruFacebook = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruFacebook,
})
const TruFilledArrow = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruFilledArrow,
})
const TruFilters = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruFilters,
})
const TruFour = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruFour,
})
const TruGasElectricity = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruGasElectricity,
})
const TruHamburgerSimple = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruHamburgerSimple,
})
const TruHome = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruHome,
})
const TruHouse = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruHouse,
})
const TruInfo = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruInfo,
})
const TruInformation = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruInformation,
})
const TruLetter = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruLetter,
})
const TruLinkedIn = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruLinkedIn,
})
const TruLocation = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruLocation,
})
const TruMagnifier = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruMagnifier,
})
const TruMinus = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruMinus,
})
const TruMobile = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruMobile,
})
const TruMoneyFilter = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruMoneyFilter,
})
const TruOne = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruOne,
})
const TruPerson = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruPerson,
})
const TruPhoneSimple = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruPhoneSimple,
})
const TruPhone = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruPhone,
})
const TruPlus = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruPlus,
})
const TruPoundCircle = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruPoundCircle,
})
const TruQuestionFilled = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruQuestionFilled,
})
const TruQuestion = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruQuestion,
})
const TruSmile = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruSmile,
})
const TruSms = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruSms,
})
const TruSort = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruSort,
})
const TruStarFilled = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruStarFilled,
})
const TruStarHalfFilled = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruStarHalfFilled,
})
const TruStarOutlined = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruStarOutlined,
})
const TruThree = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruThree,
})
const TruThumbDown = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruThumbDown,
})
const TruThumbUp = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruThumbUp,
})
const TruTick = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruTick,
})
const TruTv = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruTv,
})
const TruTwitter = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruTwitter,
})
const TruTwo = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruTwo,
})
const TruVan = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruVan,
})
const TruWarning = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruWarning,
})
const TruBanking = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruBanking,
})
const TruBullet = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruBullet,
})
const TruCarInsurance = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruCarInsurance,
})
const TruCreditCard = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruCreditCard,
})
const TruCreditCardOutline = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruCreditCardOutline,
})
const TruCurrentAccount = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruCurrentAccount,
})
const TruFacebook2 = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruFacebook2,
})
const TruHeartOutline = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruHeartOutline,
})
const TruInvestments = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruInvestments,
})
const TruLoans = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruLoans,
})
const TruMortgages = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruMortgages,
})
const TruMortgagesOutline = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruMortgagesOutline,
})
const TruOtherOutline = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruOtherOutline,
})
const TruPencil = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruPencil,
})
const TruPersonCircle = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruPersonCircle,
})
const TruPiggyBank = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruPiggyBank,
})
const TruPiggyBankOutline = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruPiggyBankOutline,
})
const TruReceiptOutline = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruReceiptOutline,
})
const TruSortThin = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruSortThin,
})
const TruTravelMoney = loadable(() => import('@uswitch/spark-icons/tru'), {
  resolveComponent: (components) => components.TruTravelMoney,
})

export const DynamicSparkIcon = ({ color, direction = 'up', glyph, size, ...props }) => {
  switch (glyph) {
    case 'arrow':
      switch (direction) {
        case 'up':
          return <TruArrow color={color} size={size} {...props} />
        case 'down':
          return (
            <TruArrow
              color={color}
              size={size}
              {...props}
              sx={{ transform: 'rotate(0.5turn)', ...props.sx }}
            />
          )
        case 'right':
          return (
            <TruArrow
              color={color}
              size={size}
              {...props}
              sx={{ transform: 'rotate(0.25turn)', ...props.sx }}
            />
          )
        case 'left':
          return (
            <TruArrow
              color={color}
              size={size}
              sx={{ transform: 'rotate(0.75turn)', ...props.sx }}
            />
          )
        default:
          return <TruArrow color={color} direction={direction} size={size} {...props} />
      }
    case 'arrow-circle':
      return <TruArrowCircle color={color} size={size} {...props} />
    case 'banking':
      return <TruBanking color={color} size={size} {...props} />
    case 'bill':
      return <TruBill color={color} size={size} {...props} />
    case 'book':
      return <TruBook color={color} size={size} {...props} />
    case 'book-closed':
      return <TruBookClosed color={color} size={size} {...props} />
    case 'bookmark':
      return <TruBookmark color={color} size={size} {...props} />
    case 'bookmark-filled':
      return <TruBookmarkFilled color={color} size={size} {...props} />
    case 'bullet':
      return <TruBullet color={color} size={size} {...props} />
    case 'calendar':
      return <TruCalendar color={color} size={size} {...props} />
    case 'car':
      return <TruCar color={color} size={size} {...props} />
    case 'caret':
      switch (direction) {
        case 'up':
          return <TruCaret color={color} size={size} {...props} />
        case 'down':
          return (
            <TruCaret
              color={color}
              size={size}
              {...props}
              sx={{ transform: 'rotate(0.5turn)', ...props.sx }}
            />
          )
        case 'right':
          return (
            <TruCaret
              color={color}
              size={size}
              {...props}
              sx={{ transform: 'rotate(0.25turn)', ...props.sx }}
            />
          )
        case 'left':
          return (
            <TruCaret
              color={color}
              size={size}
              {...props}
              sx={{ transform: 'rotate(0.75turn)', ...props.sx }}
            />
          )
        default:
          return <TruArrow color={color} size={size} {...props} />
      }
    case 'caretFinal':
      switch (direction) {
        case 'up':
          return <TruCaretFinal color={color} size={size} {...props} />
        case 'down':
          return (
            <TruCaretFinal
              color={color}
              sx={{ transform: 'rotate(0.5turn)' }}
              size={size}
              {...props}
            />
          )
        case 'right':
          return (
            <TruCaretFinal
              color={color}
              sx={{ transform: 'rotate(0.25turn)' }}
              size={size}
              {...props}
            />
          )
        case 'left':
          return (
            <TruCaretFinal
              color={color}
              sx={{ transform: 'rotate(0.75turn)' }}
              size={size}
              {...props}
            />
          )
        default:
          return <TruCaretFinal color={color} direction={direction} size={size} {...props} />
      }
    case 'car-insurance':
      return <TruCarInsurance color={color} size={size} {...props} />
    case 'check':
      return <TruCheck color={color} size={size} {...props} />
    case 'check-circle':
      return <TruCheckCircle color={color} size={size} {...props} />
    case 'clock':
      return <TruClock color={color} size={size} {...props} />
    case 'close':
      return <TruClose color={color} size={size} {...props} />
    case 'checkmark':
      return <TruCheckmark color={color} size={size} {...props} />
    case 'conversation':
      return <TruConversation color={color} size={size} {...props} />
    case 'credit-card':
      return <TruCreditCard color={color} size={size} {...props} />
    case 'credit-card-outline':
      return <TruCreditCardOutline color={color} size={size} {...props} />
    case 'cross':
      return <TruCross color={color} size={size} {...props} />
    case 'current-account':
      return <TruCurrentAccount color={color} size={size} {...props} />
    case 'edit':
      return <TruEdit color={color} size={size} {...props} />
    case 'email':
      return <TruEmail color={color} size={size} {...props} />
    case 'email-filled':
      return <TruEmailFilled color={color} size={size} {...props} />
    case 'error':
      return <TruError color={color} size={size} {...props} />
    case 'facebook':
      return <TruFacebook color={color} size={size} {...props} />
    case 'facebook2':
      return <TruFacebook2 color={color} size={size} {...props} />
    case 'filled-arrow':
      return <TruFilledArrow color={color} size={size} {...props} />
    case 'filters':
      return <TruFilters color={color} size={size} {...props} />
    case 'four':
      return <TruFour color={color} size={size} {...props} />
    case 'gas-electricity':
      return <TruGasElectricity color={color} size={size} {...props} />
    case 'hamburger-simple':
      return <TruHamburgerSimple color={color} size={size} {...props} />
    case 'heart-outline':
      return <TruHeartOutline color={color} size={size} {...props} />
    case 'home':
      return <TruHome color={color} size={size} {...props} />
    case 'house':
      return <TruHouse color={color} size={size} {...props} />
    case 'info':
      return <TruInfo color={color} size={size} {...props} />
    case 'information':
      return <TruInformation color={color} size={size} {...props} />
    case 'investments':
      return <TruInvestments color={color} size={size} {...props} />
    case 'letter':
      return <TruLetter color={color} size={size} {...props} />
    case 'linkedIn':
      return <TruLinkedIn color={color} size={size} {...props} />
    case 'location':
      return <TruLocation color={color} size={size} {...props} />
    case 'loans':
      return <TruLoans color={color} size={size} {...props} />
    case 'magnifier':
      return <TruMagnifier color={color} size={size} {...props} />
    case 'minus':
      return <TruMinus color={color} size={size} {...props} />
    case 'mobile':
      return <TruMobile color={color} size={size} {...props} />
    case 'money-filter':
      return <TruMoneyFilter color={color} size={size} {...props} />
    case 'mortgages':
      return <TruMortgages color={color} size={size} {...props} />
    case 'mortgages-outline':
      return <TruMortgagesOutline color={color} size={size} {...props} />
    case 'one':
      return <TruOne color={color} size={size} {...props} />
    case 'other-outline':
      return <TruOtherOutline color={color} size={size} {...props} />
    case 'pencil':
      return <TruPencil color={color} size={size} {...props} />
    case 'person':
      return <TruPerson color={color} size={size} {...props} />
    case 'person-bold':
      return <PersonBold color={color} size={size} {...props} />
    case 'person-circle':
      return <TruPersonCircle color={color} size={size} {...props} />
    case 'people-bold':
      return <PeopleBold color={color} size={size} {...props} />
    case 'phone':
      return <TruPhone color={color} size={size} {...props} />
    case 'phone-simple':
      return <TruPhoneSimple color={color} size={size} {...props} />
    case 'piggy-bank':
      return <TruPiggyBank color={color} size={size} {...props} />
    case 'piggy-bank-outline':
      return <TruPiggyBankOutline color={color} size={size} {...props} />
    case 'plus':
      return <TruPlus color={color} size={size} {...props} />
    case 'pound-circle':
      return <TruPoundCircle color={color} size={size} {...props} />
    case 'receipt-outline':
      return <TruReceiptOutline color={color} size={size} {...props} />
    case 'question':
      return <TruQuestion color={color} size={size} {...props} />
    case 'question-filled':
      return <TruQuestionFilled color={color} size={size} {...props} />
    case 'smile':
      return <TruSmile color={color} size={size} {...props} />
    case 'sms':
      return <TruSms color={color} size={size} {...props} />
    case 'sort':
      return <TruSort color={color} size={size} {...props} />
    case 'sort-thin':
      return <TruSortThin color={color} size={size} {...props} />
    case 'three':
      return <TruThree color={color} size={size} {...props} />
    case 'tick':
      return <TruTick color={color} size={size} {...props} />
    case 'tv':
      return <TruTv color={color} size={size} {...props} />
    case 'two':
      return <TruTwo color={color} size={size} {...props} />
    case 'thumb-up':
      return <TruThumbUp color={color} size={size} {...props} />
    case 'thumb-down':
      return <TruThumbDown color={color} size={size} {...props} />
    case 'travel-money':
      return <TruTravelMoney color={color} size={size} {...props} />
    case 'twitter':
      return <TruTwitter color={color} size={size} {...props} />
    case 'star-filled':
      return <TruStarFilled color={color} size={size} {...props} />
    case 'star-outlined':
      return <TruStarOutlined color={color} size={size} {...props} />
    case 'star-half-filled':
      return <TruStarHalfFilled color={color} size={size} {...props} />
    case 'van':
      return <TruVan color={color} size={size} {...props} />
    case 'warning':
      return <TruWarning color={color} size={size} {...props} />
    // Temporary icons
    case 'edit-journey':
      return <TruEditJourney color={color} size={size} {...props} />
    default:
      return null
  }
}
